import React from 'react';
import Communities from '../../components/Community/Communities';
import Head from '../../components/Header/Head';
import withApollo from '../../lib/withApollo';

const CommunitiesPage = () => {
  return (
    <>
      <Head
        title="Communities"
        description="Join travel communities and connect with fellow travelers around the world."
      />
      <Communities />
    </>
  );
};

export default withApollo(CommunitiesPage);
